import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { login } from '../api';
import { setStoredAuthState } from '../auth';
import styles from './Login.module.css';
import { useLang } from '../i18n/LanguageContext';
import { loginText } from '../i18n/pages/login';

const BookIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
  </svg>
);

const Login: React.FC = () => {
  useEffect(() => { fetch('/api/public/pageview?page=login').catch(() => {}); }, []);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { lang } = useLang();
  const t = loginText[lang];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const data = await login(email, password);
      setStoredAuthState({
        token: data.token,
        email: data.email,
        role: data.role,
        userId: data.userId,
      });
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.message || err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginPage}>
      <div className={styles.loginContainer}>
        <div className={styles.logo}>
          <div className={styles.logoIcon}><BookIcon /></div>
          <span className={styles.logoText}>Guestbook<span>.cz</span></span>
        </div>

        <div className={styles.title}>{t.title}</div>
        <div className={styles.subtitle}>{t.subtitle}</div>

        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.label}>{t.emailLabel}</label>
            <input className={styles.input} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder={t.emailPlaceholder} required />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label}>{t.passwordLabel}</label>
            <input className={styles.input} type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder={t.passwordPlaceholder} required />
          </div>
          <button className={styles.button} type="submit" disabled={loading}>
            {loading ? t.submittingBtn : t.submitBtn}
          </button>
        </form>

        {error && <div className={styles.error}>{error}</div>}

        <div className={styles.footer}>
          <Link to="/forgot-password">{t.forgotLink}</Link>
        </div>
        <div className={styles.footer}>
          {t.noAccount}{' '}
          <Link to="/register">{t.registerLink}</Link>
        </div>
        <div className={`${styles.footer} ${styles.footerQuiet}`}>
          <Link to="/privacy/measurement">{t.privacyLink}</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
